"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _DeleteMarkerEntry_1 = require("./_DeleteMarkerEntry");
exports._DeleteMarkers = {
    type: "list",
    flattened: true,
    member: {
        shape: _DeleteMarkerEntry_1._DeleteMarkerEntry
    }
};
//# sourceMappingURL=_DeleteMarkers.js.map